// pages/ErrorPage.js
import { Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ErrorPage = ({ code }) => {
    const navigate = useNavigate();
    
    const handleGoBack = () => {
        const token = localStorage.getItem('access_token');
        navigate(token ? '/dashboard' : '/');
    };

    return (
        <Container sx={{ textAlign: 'center', mt: 4 }}>
            <Typography variant="h1">{code}</Typography>
            <Typography variant="h5" sx={{ mb: 2 }}>
                {code === 404 ? 'Page Not Found' : 'Something Went Wrong'}
            </Typography>
            <Button 
                variant="contained" 
                onClick={handleGoBack}
            >
                {localStorage.getItem('access_token') ? 'Return to Dashboard' : 'Return to Home'}
            </Button>
        </Container>
    );
};

export default ErrorPage;